import React, { useCallback } from 'react'
import { Button } from 'reactstrap'

import Checkbox from 'components/Checkbox'
import Switch from 'components/Switch'
import { CheckoutAdditionalField } from '../types'
import Icon from 'components/Icon'
import styled from 'styled-components'

const CustomButton = styled.button`
  background: none;
  border: none;
  outline: none;
`

type Props = {
  field: CheckoutAdditionalField
  index: number
  onUpdateField: (index: number, updatedField: CheckoutAdditionalField) => void
  onClickEdit: (index: number) => void
  onClickRemove: (index: number) => void
  canUpdate: boolean
}

const CheckoutAdditionalFieldRow: React.FC<Props> = ({
  field,
  index,
  onUpdateField,
  onClickEdit,
  onClickRemove,
  canUpdate,
}) => {

  const handleChangeRequired = useCallback(
    (checked: boolean) => {
      onUpdateField(index, { ...field, requiredFlag: checked })
    },
    [index, field, onUpdateField]
  )

  const handleChangeVisibility = useCallback(
    (checked: boolean) => {
      onUpdateField(index, {
        ...field,
        displayFlag: checked,
        requiredFlag: checked ? field.requiredFlag : false,
      })
    },
    [index, field, onUpdateField]
  )

  const handleEdit = useCallback(() => {
    onClickEdit(index)
  }, [index, onClickEdit])

  const handleRemove = useCallback(() => {
    onClickRemove(index)
  }, [index, onClickRemove])

  return (
    <tr className="border-bottom" style={{ height: 48 }}>
      <td className="pl-3">
        {field.displayName ? field.displayName : <div style={{ color: '#CCC' }}>未設定</div>}
      </td>

      <td>
        <div className="d-flex justify-content-center align-items-center" />
      </td>

      <td className="text-center">
        <Button
          color="primary"
          className="rounded-pill"
          onClick={handleEdit}
          disabled={!canUpdate}
        >
          項目編集
        </Button>
      </td>

      <td className="text-center">
        <div style={{ marginTop: -14, marginLeft: -22 }}>
          <Checkbox
            label=""
            checked={field.requiredFlag}
            disabled={!canUpdate || !field.displayFlag}
            isGray={!canUpdate}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeRequired(e.target.checked)}
          />
        </div>
      </td>

      <td className="d-flex justify-content-center">
        <Switch
          checked={field.displayFlag}
          disabled={!canUpdate}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeVisibility(e.target.checked)}
        />
      </td>

      {canUpdate && !field.id && (
        <td className="text-center">
          <CustomButton onClick={handleRemove}>
            <Icon width={''} height={''} src="/assets/svgs/circle-minus.svg" />
          </CustomButton>
        </td>
      )}
    </tr>
  )
}

export default React.memo(CheckoutAdditionalFieldRow)
